import Extend from 'flarum/common/extenders';
import Discussion from 'flarum/common/models/Discussion';
import Post from 'flarum/common/models/Post';
import commonExtend from '../common/extend';
export default [...commonExtend, new Extend.Model(Discussion).attribute('matchSignals'), new Extend.Model(Post).attribute('matchSignals')];